import React, { useState } from 'react';
import { Card, Form, Input, Select, Button, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import AdminUserService from "../../../../services/AdminUserService";

const { Option } = Select;

const CreateUser = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const userData = {
                username: values.username,
                fullName: values.fullName,
                iin: values.iin,
                phone: values.phone,
                email: values.email,
                registrationAddress: values.registrationAddress,
                residenceAddress: values.residenceAddress,
                businessType: values.businessType,
                password: values.password,
            };

            await AdminUserService.createUser(userData);

            message.success(<IntlMessage id={'dashboard.admin.createUser.success'} fallback={'Пользователь успешно создан'} />);
            form.resetFields();
        } catch (error) {
            console.error('Error creating user:', error);
            message.error(<IntlMessage id={'dashboard.admin.createUser.error'} fallback={'Не удалось создать пользователя'} />);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card 
            title={
                <>
                    <PlusOutlined style={{ marginRight: 8 }} />
                    <IntlMessage id={'dashboard.admin.createUser.title'} fallback={'Создать нового пользователя'} />
                </>
            }
            style={{ height: '100%' }}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    name="username"
                    label={<IntlMessage id={'username'} fallback={'Имя пользователя'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.usernamePlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="fullName"
                    label={<IntlMessage id={'fullName'} fallback={'ФИО'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.fullNamePlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="iin"
                    label={<IntlMessage id={'iin'} fallback={'ИИН'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { len: 12, message: t('dashboard.admin.createUser.iinLength') }
                    ]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.iinPlaceholder')} maxLength={12} />
                </Form.Item>

                <Form.Item
                    name="phone"
                    label={<IntlMessage id={'phone'} fallback={'Контактный телефон'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.phonePlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="email"
                    label={<IntlMessage id={'email'} fallback={'Email'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { type: 'email', message: t('dashboard.admin.createUser.emailInvalid') }
                    ]}
                >
                    <Input placeholder="example@mail.com" />
                </Form.Item>

                <Form.Item
                    name="registrationAddress"
                    label={<IntlMessage id={'registrationAddress'} fallback={'Адрес регистрации'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.registrationAddressPlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="residenceAddress"
                    label={<IntlMessage id={'residenceAddress'} fallback={'Адрес фактического проживания'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder={t('dashboard.admin.createUser.residenceAddressPlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="businessType"
                    label={<IntlMessage id={'businessType'} fallback={'Тип хозяйства'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Select placeholder={t('dashboard.admin.createUser.businessTypePlaceholder')}>
                        <Option value="IP">{t('dashboard.admin.createUser.businessType.ip')}</Option>
                        <Option value="KH">{t('dashboard.admin.createUser.businessType.kh')}</Option>
                        <Option value="TOO">{t('dashboard.admin.createUser.businessType.too')}</Option>
                        <Option value="PK">{t('dashboard.admin.createUser.businessType.pk')}</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="password"
                    label={<IntlMessage id={'dashboard.admin.createUser.passwordLabel'} fallback={'Пароль для входа'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { min: 6, message: t('dashboard.admin.createUser.passwordMin') }
                    ]}
                >
                    <Input.Password placeholder={t('dashboard.admin.createUser.passwordPlaceholder')} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        <IntlMessage id={'dashboard.admin.createUser.submit'} fallback={'Создать пользователя'} />
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default CreateUser;